import * as React from 'react';

function SvgChatbubble(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M4.001 22a1.147 1.147 0 01-1.088-1.49l.823-2.974c.034-.11-.005-.22-.055-.308l-.01-.018-.033-.047-.038-.055-.008-.012A9.627 9.627 0 012 11.793c-.008-2.57.998-5 2.833-6.843C6.733 3.048 9.273 2 11.992 2a10.152 10.152 0 016.347 2.225 9.789 9.789 0 013.447 5.566 9.831 9.831 0 01-2.633 8.967c-1.852 1.875-4.338 2.905-7.001 2.905-.938 0-2.137-.24-2.713-.402-.693-.194-1.35-.446-1.422-.473a.675.675 0 00-.499.007l-.038.014-3.012 1.089A1.314 1.314 0 014 22z" })));
}

export default SvgChatbubble;
